var $34eea9d53e2e4d7c$exports = {};
$34eea9d53e2e4d7c$exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};


export {$34eea9d53e2e4d7c$exports as default};
//# sourceMappingURL=de-DE.mjs.map
